<template>
	<div class = "page_padding header_top">
				  
				  <span><i class = "iconfont" style = "color:#ff481e">&#xe6c7;</i>收藏余米科技网(yjyumi .com)</span>
				   <span><i class = "iconfont" style = "color:#ff481e">&#xe6c7;</i>关注微信</span>
				    <span class = "user_status">
						<span>您好，{{(Login.username)?Login.username:'请登录' }} </span>
						 
						 
						 <span v-if = "Login.username" @click = "toCenter" class = "finger" style="color: #284fcf;"> [个人中心] </span> 
						 <span v-if = "!Login.username" class="finger" style="color: #284fcf;" @click="toSignUp('enterprise')">企业注册|</span> 
						       <span v-if = "!Login.username" class="finger" style="color: #284fcf;" @click="toSignUp('supplier')">个人注册|</span>            
						中国余米科技网：科技领先品牌
					</span>
		<sign-up style = "position: absolute;" ref  = "signUpForm" :type = "type"></sign-up>		
	</div>
</template>

<script>
	import signUp from '../signUp/signUp.vue'
	import {mapGetters} from 'vuex'
	export default{
				computed:{
	...mapGetters(['Login'])
},
		components:{
			signUp
		},
		data(){
			return {
				type:""
			}
		},
		methods:{
			toSignUp(type){
				this.$refs["signUpForm"].type = type
				this.$refs["signUpForm"].getCode()
				this.$refs["signUpForm"].dialogTableVisible = true			
			},
			toCenter(){

				this.$router.push({
					name: 'supplier'
				})
			
			}
		}
	}
</script>

<style>
	.header_top{
		display: flex;
		width: 78vw;
		height: 100%;
		justify-content: space-between;
		 background-color: #eff1f3;
		height: 3vw;
		
	}
	.header_top>span:nth-child(2){
		
		position: absolute;
		left: 25.4vw;
		
	}
	.header_top>span{
		font-size: 1vw;
		line-height: 3vw;
		color: #555555;
	}
	
</style>
